import React from 'react';
export function WhySection() {
  return <section className="bg-ice px-3 py-4 sm:px-6" data-id="element-166" data-mp="h56iq6gptrl6">
      <div className="mx-auto max-w-2xl space-y-2.5" data-id="element-167" data-mp="13uqgu53jf7pz">
        <article className="rounded-md border border-navy/15 border-l-[5px] border-l-brightblue bg-white p-3 shadow-sm" data-id="element-168" data-mp="13t6zsca24sn5">
          <h2 className="font-heading text-[1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.45rem]" data-id="element-169" data-mp="1dl2z1qnvqosy">
            What if your cleaning business systems were already ready?
          </h2>
          <p className="mt-1 text-[0.8rem] leading-[1.35] text-muted sm:text-[0.95rem]" data-id="element-170" data-mp="1mlhlitcky9y1">
            You already know how important professional cleaning is. The problem
            is having to constantly manage clients, quotes, cleaning checklists,
            schedules, messages and daily operations. Where did that client send
            the access instructions? What exactly was included in this service?
            Which jobs need confirmation? Who still needs a follow-up? Instead
            of relying on scattered messages, notes and improvised documents,{' '}
            <span className="font-semibold text-brightblue" data-id="element-171" data-mp="2ihq1laa5b8bo">
              CLEANING READY™
            </span>{' '}
            gives you ready-to-use resources covering 6 essential areas of
            cleaning business operations.
          </p>
          <p className="mt-1 font-heading text-[0.72rem] font-bold uppercase tracking-wide text-brightblue sm:text-sm" data-id="element-172" data-mp="24p1g822crcs6">
            Organize. Prepare. Clean. Control.
          </p>
        </article>

        <article className="rounded-md border border-gold/50 border-l-[5px] border-l-gold bg-white p-3 shadow-sm" data-id="element-173" data-mp="2wf67mkoj502w">
          <h2 className="font-heading text-[1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.45rem]" data-id="element-174" data-mp="2schyebvwlr5e">
            😩 Stop rebuilding your cleaning business systems from scratch
          </h2>
          <p className="mt-1 text-[0.8rem] leading-[1.35] text-muted sm:text-[0.95rem]" data-id="element-175" data-mp="1h08sgsvvwb8n">
            Your time should be spent serving clients and completing jobs — not
            recreating forms, checklists, quotes and messages every day.
            CLEANING READY™ brings everything together. Clients • Cleaning
            Services • Quotes • Scheduling • Communication • Operations
            Everything is organized so you can find the right resource,
            customize it and use it in your cleaning business.
          </p>
          <p className="mt-1 font-heading text-[0.72rem] font-bold uppercase tracking-wide text-gold sm:text-sm" data-id="element-176" data-mp="18jhu19f8b0q1">
            Less improvisation. More operational control.
          </p>
        </article>

        <article className="rounded-md bg-navy p-3 text-white shadow-sm" data-id="element-177" data-mp="ks2rpgngcjes">
          <h2 className="font-heading text-[1rem] font-extrabold uppercase leading-tight sm:text-[1.45rem]" data-id="element-178" data-mp="kpzpzzcxt1u8">
            ⏱️ Less organizing. More ready-to-use business tools.
          </h2>
          <p className="mt-1 text-[0.8rem] leading-[1.35] text-white/90 sm:text-[0.95rem]" data-id="element-179" data-mp="bs67psc0c8q2">
            Need a new client intake form? It’s ready. Need a professional
            cleaning checklist? It’s ready. Quotes, schedules, client messages
            or quality-control tools? They’re organized too.
          </p>
          <p className="mt-1 font-heading text-[0.72rem] font-bold uppercase tracking-wide text-gold sm:text-sm" data-id="element-180" data-mp="3odbkuzxh8j6g">
            Open the system. Choose the tool. Customize it. Use it.
          </p>
        </article>
      </div>
    </section>;
}